import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import '../../assets/css/Leads.css'
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";


const ServiceHistory = () => {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [workshops, setWorkshops] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [details, setdetails] = useState('');
  const [date, setdate] = useState(null);
  const [page, setPage] = useState(1);

  const imageUrl = "https://devapi.bykit.in/storage/users/";
  const invoiceUrl = "https://devapi.bykit.in/storage/brands/";

  const [selectedId, setSelectedId] = useState(null);
  const [selecteduserId, setSelecteduserId] = useState('');

  const [show, setShow] = useState(false);


  const offcanvasRef = useRef(null);
  const handlePageChange = (newPage) => setPage(newPage);

  const handleRowsPerPageChange = (newRows) => {
    setRowsPerPage(newRows);
    setPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOffcanvas &&
        offcanvasRef.current &&
        !offcanvasRef.current.contains(event.target)
      ) {
        setShowOffcanvas(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOffcanvas]);


  useEffect(() => {
    getLeadsData();
    getAdminData();
  }, [page, rowsPerPage]);

  useEffect(() => {
    filterData();
  }, [fromDate, toDate, leads]);

  const handleShowDetails = (lead) => {
    setSelectedLead(lead);
    setShowOffcanvas(true);
  };

  const labels = [
    "Meter",
    "Front Angle",
    "Right angle",
    "Left angle",
    "Back side",
    "Any dent/scratches"
  ];

  const assignModelOpen = (lead, user) => {
    setSelectedId(lead);
    setSelecteduserId(user);
    setShow(true)
  }

  let formattedPickupTime = ''
  if (selectedLead && selectedLead.pickup_time) {
    const pickup = new Date(selectedLead.pickup_time);
    formattedPickupTime = `${String(pickup.getDate()).padStart(2, '0')}-${String(pickup.getMonth() + 1).padStart(2, '0')}-${pickup.getFullYear()} ${String(pickup.getHours()).padStart(2, '0')}:${String(pickup.getMinutes()).padStart(2, '0')}`;
  }

  let formattedreachedTime = ''
  if (selectedLead && selectedLead.reached_workshop_time) {
    const reached = new Date(selectedLead.reached_workshop_time);
    formattedreachedTime = `${String(reached.getDate()).padStart(2, '0')}-${String(reached.getMonth() + 1).padStart(2, '0')}-${reached.getFullYear()} ${String(reached.getHours()).padStart(2, '0')}:${String(reached.getMinutes()).padStart(2, '0')}`;
  }

  let formattestartTime = ''
  if (selectedLead && selectedLead.start_service_time) {
    const start = new Date(selectedLead.start_service_time);
    formattestartTime = `${String(start.getDate()).padStart(2, '0')}-${String(start.getMonth() + 1).padStart(2, '0')}-${start.getFullYear()} ${String(start.getHours()).padStart(2, '0')}:${String(start.getMinutes()).padStart(2, '0')}`;
  }

  let formattecompleteTime = ''
  if (selectedLead && selectedLead.service_complete_time) {
    const complete = new Date(selectedLead.service_complete_time);
    formattecompleteTime = `${String(complete.getDate()).padStart(2, '0')}-${String(complete.getMonth() + 1).padStart(2, '0')}-${complete.getFullYear()} ${String(complete.getHours()).padStart(2, '0')}:${String(complete.getMinutes()).padStart(2, '0')}`;
  }

  let formatteDropTime = ''
  if (selectedLead && selectedLead.drop_time) {
    const drop = new Date(selectedLead.drop_time);
    formatteDropTime = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()} ${String(drop.getHours()).padStart(2, '0')}:${String(drop.getMinutes()).padStart(2, '0')}`;
  }


  let insuranceexpiry = ''
  if (selectedLead && selectedLead.insurance_expiry_date) {
    const drop = new Date(selectedLead.insurance_expiry_date);
    insuranceexpiry = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()}`;
  }


  const formatDateForMySQL = (isoDate) => {
    const dateObj = new Date(isoDate);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };




  const handleAssign = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const payload = {
      booking_id: selectedId,
      user_id: selecteduserId,
      date: formatDateForMySQL(date),
      message: details
    }

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/add_nextservicereminder?type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Estimation added successfully!", { position: "top-right" });
        setShow(false);
        getLeadsData();
      } else {
        toast.error("Failed to add estimation. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding estimation:", error);
      setShow(false);
    }
  };


  const getAdminData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        "https://devapi.bykit.in/api/admin/workshop/list??type=live",
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('workshop', response)

      if (response.data && response.data.data) {
        setWorkshops(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const formatDateToDMY = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if invalid
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };



  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const url = "https://devapi.bykit.in/api/admin/getallbooking??type=live"
    const payload = {
      user_id: 1
    }
    try {
      const response = await axios.post(url, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("All Bookings:", response.data);

      if (response.data?.data) {
        setLeads(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error.response?.data || error.message);
    }
  };



  const columns = [
    {
      name: "Service Date",
      cell: (row) => (
        <div>
          <p>{row.date || "N/A"}</p>
          {/* <span className={`text-white font-bold ${row.status === 0 ? "deactvie_btn" : "active_btn"}`}>
            {row.status === 0 ? "Deactive" : "Active"}
          </span> */}
        </div>
      ),
      sortable: true
    },

    { name: "Customer Name", selector: (row) => row.customer_name || "N/A", sortable: true },
    { name: "Email", selector: (row) => row.email || "N/A", sortable: true },
    { name: "Phone", selector: (row) => row.phone || "N/A", sortable: true },
    { name: "Vehicle Number", selector: (row) => row.vehicle_name || "N/A", sortable: true },
    {
      name: "Invoice Amount",
      selector: (row) => row.status_estimate === 2 ? row.pickup_price : row.invoice_amount,
      sortable: true
    },
    {
      name: "Action",
      cell: (row, index) => (
        <div className="d-flex justify-content-end">
          <button className="edit_btn me-2"
            data-tooltip-id={`view-tooltip-${row.id}`}
            data-tooltip-content="View Details"
            onClick={() => handleShowDetails(row)}>
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="me-1 iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178"></path>
                <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
              </g>
            </svg>
          </button>
          <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />
          {row.nextservice_date ? 'Next Service Date: ' + formatDateToDMY(row.nextservice_date) : <button data-tooltip-id={`view-tooltip-${row.id}`} data-tooltip-content="Send Service Reminder" className="edit_btn me-2" onClick={() => assignModelOpen(row.id, row.user_id)}><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l4 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
          </svg>
          </button>}
        </div>
      ),
    },
  ];

  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [filteredLeads, setFilteredLeads] = useState([]);

  const handleWorkshopSelect = (workshop) => {
    setSelectedWorkshop(workshop);

    console.log("Selected Workshop:", workshop);
    console.log("Parent ID:", workshop.id);


    const matchedLeads = leads.filter((lead) => lead.workshop_id === workshop.id);
    setFilteredLeads(matchedLeads);
    console.log("Filtered Leads:", matchedLeads);
  };

  const filterData = () => {
    let filtered = leads;

    if (fromDate && toDate) {
      filtered = filtered.filter(lead => {
        const leadDate = new Date(lead.date);
        return leadDate >= new Date(fromDate) && leadDate <= new Date(toDate) && lead.status === 16;
      });
    }

    if (search) {
      filtered = filtered.filter(lead =>
        lead.name?.toLowerCase().includes(search.toLowerCase()) ||
        lead.email?.toLowerCase().includes(search.toLowerCase()) ||
        lead.phone?.includes(search) && lead.status === 16
      );
    }

    // filtered = filtered.filter(lead => {
    //   const leadDate = new Date(lead.date);
    //   return leadDate >= new Date(fromDate) && leadDate <= new Date(toDate) && lead.status === 16;
    // });


    filtered = filtered.filter(lead => {
      return lead.status === 16;
    });



    setFilteredLeads(filtered);
  };

 // const testLeads = [...filteredLeads, ...filteredLeads, ...filteredLeads, ...filteredLeads, ...filteredLeads, ...filteredLeads, ...filteredLeads, ...filteredLeads]; // 3x data

  return (
    <div className="container data-table-container p-2">
      {!showForm && (
        <div>
          <div className="d-flex align-items-center gap-3">
            <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
            </svg>
            <p className="m-0">Service History</p>
          </div>
          <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
            <div>
              <h4 className='dashboard_head ps-3 pb-4'>Service History</h4>
            </div>
            <hr></hr>
            <div className="d-flex justify-content-between my-3 px-3">


              {/* <div>
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle dropdown_workshop text-light fw-bold"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {selectedWorkshop ? selectedWorkshop.name : "Select Workshop"}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {workshops.length > 0 ? (
                      workshops.map((workshop) => (
                        <li key={workshop.id}>
                          <button
                            className="dropdown-item "
                            onClick={() => handleWorkshopSelect(workshop)}>
                            {workshop.name}
                          </button>
                        </li>
                      ))
                    ) : (
                      <li>
                        <span className="dropdown-item">No Workshops Available</span>
                      </li>
                    )}
                  </ul>
                </div>
              </div> */}



              <div className="d-flex gap-2">
                {/* <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                /> */}


                <DatePicker
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  placeholderText="Select from date"
                />

                <DatePicker
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  placeholderText="Select to date"
                />


              </div>
            </div>

            <DataTable
              columns={columns}
              data={filteredLeads}
              pagination
              
              paginationPerPage={rowsPerPage}
              paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              responsive
              customStyles={{
                headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
                pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
                cells: {
                  style: {
                    padding: "10px",
                    margin: "0",
                  },
                },

                headCells: {
                  style: {
                    padding: "10px",
                    margin: "0",
                  },
                },
              }}
            />
          </div>
        </div>
      )}

      <div>
        <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>

            {selectedLead && (
              <div className="lead-details" ref={offcanvasRef}>

                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Service Details</h4>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Customer Details</h4>
                  </div>
                </div>
                <hr style={{ marginBottom: 10, marginTop: 10 }} />

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Date</h4>
                        <p className="detail_text">{selectedLead.date}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Type</h4>
                        <p className="detail_text">
                          {selectedLead.service_type === 0
                            ? `Free / ${selectedLead.free_service_no} Free Service`
                            : 'Paid'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Name</h4>
                        <p className="detail_text">{selectedLead.customer_name}-{selectedLead.phone}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Vehicle Number:</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">

                      <div className="col-4">
                        <h4 className="detail_title">Total Amount</h4>
                        <p className="detail_text">{selectedLead.invoice_amount || "-"}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Payment Status</h4>
                        <p className="detail_text">{selectedLead.payment_status === 1 ? "Paid" : "Unpaid"}</p>
                      </div>
                      <div className="col-4">
                        {selectedLead.invoice ?
                          <div>
                            <h4 className="detail_title">Invoice</h4>
                            <p className="detail_text"> <Link
                              to={'https://devapi.bykit.in/storage/brands/' + `${selectedLead.invoice}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              View Invoice
                            </Link></p></div> : null
                        }
                      </div>

                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Address</h4>
                        <p className="detail_text">{selectedLead.address}</p>
                      </div>

                    </div>
                  </div>
                </div>



                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/Drop</h4>
                        <div className="mt-2">
                          <span className="btn droppickup_btn btn-sm">
                            {selectedLead?.pickup_drop_facility === 0
                              ? "Pickup"
                              : selectedLead?.pickup_drop_facility === 3
                                ? "Self Pickup/Drop"
                                : selectedLead?.pickup_drop_facility === 1
                                  ? "Drop"
                                  : "Pickup & Drop"}
                          </span>
                        </div>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/drop Charges </h4>
                        <p className="detail_text">{selectedLead.pickup_price ? selectedLead.pickup_price : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">

                      </div>
                      <div className="col-6">

                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Time</h4>
                        <p className="detail_text">{formattedPickupTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Images</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.pickup_photos && selectedLead.pickup_photos.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title">Vehicle Details</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-4">
                        <h4 className="detail_title">Vehicle Number</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Brand</h4>
                        <p className="detail_text">  {selectedLead?.brand_logo && (
                          <img
                            src={selectedLead.brand_logo}
                            alt="Brand Logo"
                            style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
                            onError={(e) => (e.target.style.display = "none")}
                          />
                        )}
                        </p>
                      </div>

                      <div className="col-4">
                        <h4 className="detail_title">Model</h4>
                        <p className="detail_text">{selectedLead.model_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Workshop Reaching Time</h4>
                        <p className="detail_text">{formattedreachedTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to workshop</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.receive_photo && selectedLead.receive_photo.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Number</h4>
                        <p className="detail_text"> {selectedLead.insurance_number || "-"}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Company</h4>
                        <p className="detail_text"> {selectedLead.insurance_company || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Service Started Time</h4>
                        <p className="detail_text">{formattestartTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Complete Time</h4>
                        <p className="detail_text">{formattecompleteTime}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.insurance_copy_image ?
                        <div className="col-6">
                          <h4 className="detail_title">Insurance</h4>
                          <Link to={imageUrl + selectedLead.insurance_copy_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}

                      <div className="col-6">
                        <h4 className="detail_title">Insurance Expiry Date</h4>
                        <p className="detail_text">{insuranceexpiry != '01-01-1970' ? insuranceexpiry : "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>








                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup from workshop</h4>
                        <p className="detail_text"> {selectedLead.work_complete_photo && selectedLead.work_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to customer</h4>
                        <p className="detail_text">{selectedLead.delivery_complete_photo && selectedLead.delivery_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.rc_book_image && selectedLead.rc_book_image != 'https://devapi.bykit.in/blank-image.png' ?
                        <div className="col-12">
                          <h4 className="detail_title">RC Book:</h4>
                          <Link to={imageUrl + selectedLead.rc_book_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Drop Time</h4>
                        <p className="detail_text">{formatteDropTime}</p>
                      </div>
                      <div className="col-12">
                        <h4 className="detail_title">Message From Customer</h4>
                        <p className="detail_text">{selectedLead.message}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title" style={{ marginTop: 30 }}>Ratings</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-6">
                        <h4 className="detail_title">Ratings for Delivery Boy</h4> {selectedLead.rate_delivaryboy && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_delivaryboy ? "star filled" : "star"}>
                            {i < selectedLead.rate_delivaryboy ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_delivaryboy ? <p className="detail_text">{selectedLead.comment_delivaryboy}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                      <div className="col-6">

                        <h4 className="detail_title">Ratings for Service</h4> {selectedLead.rate_workshop && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_workshop ? "star filled" : "star"}>
                            {i < selectedLead.rate_workshop ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_workshop ? <p className="detail_text">{selectedLead.comment_workshop}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>




      {/* Modal */}
      {showModal && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>
            <div className='p-3'>
              <p className='delete_text'>Are you sure, do you want to deactivate ?</p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={() => {
                // Call your function here
                console.log("Marked as Converted");
                setShowModal(false);
              }} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}


      {show && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light"> Next Service due date</h3>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShow(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAssign}>
                  <div className="mb-3">
                    <div className="form-label">Date</div><br />

                    <DatePicker
                      selected={date}
                      onChange={(date) => setdate(date)}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      placeholderText="Select date"
                      style={{ margin: '30px' }}
                    />


                  </div>

                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <input
                      name="details"
                      className="form-control"
                      value={details}
                      onChange={(e) => setdetails(e.target.value)}
                      required ></input>
                  </div>

                  <div className="d-flex justify-content-end  me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default ServiceHistory;
